import { useSatuEventTracker } from 'utils/satuEvent'

const SATU_EVENT_NAME = 'gpk_skp_fe_user_action_v1'

export interface GpkTrackEventParams {
  activityType: GpkTrackEventActivityType
  screenName: GpkTrackEventScreenName
  eventTrigger?: GpkTrackEventScreenName
  attributes?: Record<string, string>
}

export type GpkTrackEventScreenName =
  | 'perencanaan_pegawai'
  | 'perencanaan_tk'
  | 'perencanaan_ppk'

export type GpkTrackEventActivityType =
  | 'view_pelaksanaan_tugas_pokok'
  | 'save_pelaksanaan_tugas_pokok'
  | 'view_praktik_kinerja'
  | 'save_praktik_kinerja'
  | 'view_pengembangan_kompetensi'
  | 'save_pengembangan_kompetensi'
  | 'view_perilaku_kerja'
  | 'save_perilaku_kerja'
  | 'submit'
  | 'view_daftar_perencanaan_kinerja'
  | 'view_rincian_perencanaan_kinerja'
  | 'approve'
  | 'deny'
  | 'view_daftar_perencanaan_kinerja_satu_per_satu'
  | 'view_rincian_perencanaan_kinerja_satu_per_satu'
  | 'approve_satu_per_satu'
  | 'view_daftar_perencanaan_kinerja_sekaligus'
  | 'approve_sekaligus'

export function useGpkTracker() {
  const { SETrackEvent } = useSatuEventTracker()

  const trackEvent = (params: GpkTrackEventParams) => {
    SETrackEvent({
      eventName: SATU_EVENT_NAME,
      eventParams: {
        activity_type: params.activityType,
        screen_name: params.screenName,
        event_trigger: params.eventTrigger ?? params.screenName,
        attributes: Object.entries(params.attributes ?? {}).map(
          ([key, value]) => ({
            key,
            value,
          })
        ),
      },
      sendUserData: true,
      sendDefaultParams: true,
      sendAttributes: false,
    })
  }

  return {
    trackEvent,
  }
}
